let favourites;

function getFavourites() {
  if (favourites == undefined) {
    favourites = localStorage.getItem('favourites');
    if (!favourites) {
      return [];
    }

    try {
      const data = JSON.parse(favourites);
      favourites = data || []
    } catch (e) {
      return [];
    }
  }
  return favourites;
}

function saveFavourite(favouriteTitle, favouriteUrl, type) {
  const newFavourites = getFavourites();
  let added = true;
  if (hasFavourite(favouriteTitle, type)) {
    added = false;
    newFavourites.splice(getFavouriteIndex(newFavourites, favouriteTitle, type), 1);
  } else {
    newFavourites.push({ favouriteTitle, favouriteUrl, type });
  }
  localStorage.setItem('favourites', JSON.stringify(newFavourites));
  favourites = newFavourites;
  return added;
}

function getFavouriteIndex(newFavourites, favouriteTitle, type) {
  return newFavourites.findIndex(favourite => favourite.favouriteTitle == favouriteTitle && favourite.type == type);
}

function hasFavourite(favouriteTitle, type) {
  return getFavouriteIndex(getFavourites(), favouriteTitle, type) != -1;
}


export { getFavourites, saveFavourite, hasFavourite };
